import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex items-start" }
const _hoisted_2 = { class: "flex h-5 items-center" }
const _hoisted_3 = ["value", "id", "checked", "name"]
const _hoisted_4 = { class: "ml-3 text-sm" }
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 0,
  id: "checkbox-description",
  class: "text-gray-600"
}

import { 
		nextTick,
		onMounted
	} from 'vue'

	
export default /*#__PURE__*/_defineComponent({
  __name: 'TwCheckbox',
  props: { 
		modelValue: {
			type: Boolean,
			default: null
		},
		description: {
			type: String,
			default: ''
		},
		id: {
			type: String,
			default: 'Checkbox'
		},
		label: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		}
	},
  emits: [
		'update:modelValue'
	],
  setup(__props, { emit: __emit }) {


	const props = __props

	onMounted(() => {
		// check checkbox if initial value is true
		if(props.modelValue) {
			const checkbox = document.getElementById(
				props.id,
			) as HTMLInputElement
			checkbox.checked = true
		}
	})

	const emit = __emit

	const onInput = async () => {
		const checkbox = document.getElementById(
			props.id,
		) as HTMLInputElement

		emit('update:modelValue', checkbox?.checked)
		await nextTick()
		return
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        value: __props.modelValue,
        id: __props.id,
        checked: __props.modelValue,
        "aria-describedby": "checkbox-description",
        class: "h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500",
        onInput: onInput,
        name: __props.name,
        type: "checkbox"
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", {
        for: __props.id,
        class: "font-medium text-gray-700"
      }, _toDisplayString(__props.label), 9, _hoisted_5),
      (__props.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.description), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})